import type { UserAvatar } from './useUserAvatar';
import type { QueryClient } from '@tanstack/react-query';

/**
 * Seeds the `useUserAvatar` cache from a response that already carries the avatar fields, so an avatar
 * rendered beside that user doesn't fetch data it was just handed.
 *
 * A pre-existing entry always wins: this only fills a hole, it never overwrites a fetched avatar.
 */
export const preloadUserAvatar = (queryClient: QueryClient, userAvatar: UserAvatar) => {
  const queryKey = [`/v1/users/${userAvatar.id}/avatar`];

  if (queryClient.getQueryData(queryKey)) {
    return;
  }

  queryClient.setQueryData<UserAvatar>(queryKey, userAvatar);
};
